<template>
  <el-breadcrumb
    separator-class="el-icon-arrow-right"
    class="def-w layout-breadcrumb f-start-c"
  >
    <el-breadcrumb-item
      v-for="menu in breadcrumbList"
      :key="menu.id"
      :to="getRoute(menu)"
    >
      <div v-if="menu.isQuery" class="search-item text-cut">
        {{ menu.name }}
        <i class="el-icon-close" />
      </div>
      <template v-else>
        {{ menu.name }}
      </template>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
import { mapGetters } from "vuex";
import { NAV_MENU_CODE } from "@/utils/constant";

export default {
  name: "LayoutBreadcrumb",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["activeMenuTree", "allMenusList", "curDetailTitle"]),
    breadcrumbList() {
      const homeMenu = this.allMenusList.find(
        (m) => m.code === NAV_MENU_CODE.HOME
      );
      let breadcrumbArr = [homeMenu, ...this.activeMenuTree];
      this.$route.path.includes("/detail") &&
        breadcrumbArr.push({
          name: this.curDetailTitle,
          id: Math.random(),
          path: this.$route.path,
          query: this.$route.query,
          params: this.$route.params,
        });
      this.$route.query.title &&
        breadcrumbArr.push({
          name: this.$route.query.title,
          id: Math.random(),
          isQuery: true,
        });
      breadcrumbArr = this.uniqBy(breadcrumbArr, 'id')   
      return breadcrumbArr;
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 去重
    uniqBy(arr, keyFn) {
      const seen = new Set()
      return arr.filter(obj => {
        const k = typeof keyFn === 'function' ? keyFn(obj) : obj[keyFn]
        if (seen.has(k)) return false
        seen.add(k)
        return true
      })
    },
    isLastItem(menu) {
      const index = this.breadcrumbList.findIndex((b) => b.id === menu.id);
      return index === this.breadcrumbList.length - 1 || index === -1;
    },
    getRoute(menu) {
      return this.isLastItem(menu) && !menu.isQuery
        ? null
        : {
            path: menu.path,
            params: menu.params,
            query: {
              ...menu.query,
              t: Date.now(),
            },
          };
    },
  },
};
</script>

<style scoped lang="scss">
.layout-breadcrumb {
  height: 50px;
  ::v-deep {
    .el-breadcrumb__item {
      float: none;
      white-space: nowrap;
      display: flex;
      align-items: center;
    }
    .el-breadcrumb__inner {
      line-height: 1.5;
      display: block;
      max-width: 340px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #999999;
      font-weight: 400;
      &:not(.is-link) {
        color: $--color-primary;
        &:hover {
          color: $--color-primary;
        }
      }
    }
  }
  .search-item {
    background-color: #f5f5f5;
    cursor: pointer;
    color: #666;
    padding-left: 10px;
    padding-right: 25px;
    position: relative;
    border: 1px solid #f5f5f5;
    .el-icon-close {
      font-size: 12px;
      line-height: 1;
      position: absolute;
      right: 6px;
      top: 50%;
      transform: translateY(-5px);
      color: #666;
    }
    &:hover {
      border: 1px solid $--color-primary;
      .el-icon-close {
        color: $--color-primary;
      }
    }
  }
}
</style>
